import { AxiosInstance } from 'axios';
import jwtDecode from 'jwt-decode';

import { JwtPayloadResponse } from '@/models/JwtPayloadResponse';
import { UserTypeEnum } from '@/models/User';

export function isTokenExpired(token: string): boolean {
  try {
    const decoded = jwtDecode<JwtPayloadResponse>(token);
    return new Date(decoded.exp! * 1000) < new Date(Date.now());
  } catch {
    return true;
  }
}

export async function refreshAccessTokenWithRefreshToken(
  client: AxiosInstance,
) {
  try {
    await client.post('/auth/token/refresh/');
    return true;
  } catch (error) {
    console.error('Error refreshing token');
    return Promise.reject(error);
  }
}

export function isSuperAdmin(role?: UserTypeEnum) {
  return /SUPER_ADMIN/gi.test(role || '');
}

export function isAdmin(role?: UserTypeEnum) {
  return /ADMIN/gi.test(role || '');
}

export function isContentCreator(role?: UserTypeEnum) {
  return /CONTENT_CREATOR/gi.test(role || '');
}

export function isTeacher(role?: UserTypeEnum) {
  return /TEACHER/gi.test(role || '');
}

export function isStudent(role?: UserTypeEnum) {
  return /STUDENT/gi.test(role || '');
}

export function isStaff(role?: UserTypeEnum) {
  return (
    role &&
    [
      UserTypeEnum.SUPER_ADMIN,
      UserTypeEnum.UNIT_ADMIN,
      UserTypeEnum.TEACHER,
      UserTypeEnum.CONTENT_CREATOR,
    ].includes(role)
  );
}

export const isUnitStaff = (role?: UserTypeEnum) => {
  return isUnitAdmin(role) || isTeacher(role);
};

export function isUnitAdmin(role?: UserTypeEnum) {
  return /UNIT_ADMIN/gi.test(role || '');
}
